import { format, parseISO } from 'date-fns';
import { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FacilityRejectionReasonEnum, FacilityStatusEnum, ConnectedFacility } from '../../../api';
import { Card } from '../Card';
import { ReviewConnectionDialog } from '../ConnectionRequestCard/ReviewConnectionDialog';
import { ConnectionCombinedStatusEnum } from '../ConnectionRequestsTable/ConnectionCombinedStatusEnum';
import { ConnectionCombinedStatusBadge } from '../ConnectionStatusBadge';
import { PresentationStatusControl } from '../PresentationStatusControl';

interface FacilityCardProps {
  data: ConnectedFacility;
}

export const FacilityCard = ({ data }: FacilityCardProps) => {
  const {
    id: connectedFacilityId,
    facility_status,
    facility_rejection_reason,
    facility_rejection_details,
    combined_status,
    updated_at,
  } = data;
  const { id: facilityId, name, city, state } = data.facility;
  const [selectedFacility, setSelectedFacility] = useState<ConnectedFacility | null>(null);
  const handleReviewDialogClose = () => {
    setSelectedFacility(null);
  };

  return (
    <>
      <Card.SubCard className="p-3 mt-3">
        <Row className="align-items-center justify-content-between">
          <Col xs="9">
            <Link to={`/app/organization/facilities/${facilityId}`} className="mb-2 pb-1">
              {name}
            </Link>
          </Col>
          <Col xs="3">
            <Button
              variant="outline-primary"
              className="btn btn-drop-shadow-sm px-2"
              size="sm"
              onClick={() => setSelectedFacility(data)}
            >
              Open
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs="12" className="fs-14 mb-2">
            {city}, {state}
          </Col>

          <Col xs="12" className="fs-14 mb-2">
            <ConnectionCombinedStatusBadge
              status={data?.combined_status as ConnectionCombinedStatusEnum}
            />
          </Col>

          {facility_status === FacilityStatusEnum.DENIED && (
            <Col xs="12">
              <div className="text-danger">
                {facility_rejection_reason === FacilityRejectionReasonEnum.OTHER &&
                facility_rejection_details ? (
                  <>{facility_rejection_details}</>
                ) : (
                  <>
                    {
                      window.FACILITY_REJECTION_REASONS[
                        facility_rejection_reason as FacilityRejectionReasonEnum
                      ]
                    }
                  </>
                )}
              </div>
            </Col>
          )}
          {combined_status === FacilityStatusEnum.PENDING_APPROVAL && (
            <Col xs="12" className="my-3">
              <PresentationStatusControl
                id={connectedFacilityId}
                combined_status={combined_status}
              />
            </Col>
          )}
        </Row>
        <div className="d-flex justify-content-start mt-1">
          <small>{format(parseISO(updated_at), 'LLL d, yyyy')}</small>
        </div>
      </Card.SubCard>
      {selectedFacility && (
        <ReviewConnectionDialog
          connectionRequest={selectedFacility}
          show={true}
          onSubmit={() => {}}
          closeDialog={handleReviewDialogClose}
          onAccept={() => {}}
          onReject={() => {}}
          onCancel={() => {}}
          openedFromProfile={true}
        />
      )}
    </>
  );
};
